import Vue from "vue";
import App from "./App.vue";
import OAuth from './plugins/OAuth/oauth';
import vSelect from 'vue-select';
import router from "./router/index";
import store from "./store/index";
import VeeValidate from "vee-validate";
import "./assets/tailwind.css";
import MESSAGES from "@/messages";
import handleRoles from "@/mixins/handleRoles";
import packageJson from "../package.json";
import 'vue-select/dist/vue-select.css';

Vue.directive("scroll", {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener("scroll", f);
      }
    };
    window.addEventListener("scroll", f);
  }
});

Vue.component('v-select', vSelect);
Vue.config.productionTip = false;
Vue.use(VeeValidate, { inject: false, events: 'input|blur' });


fetch("/assets/config/config.json")
  .then((response) => response.json())
  .then((config) => {
      window.config = config
      Vue.prototype.$config = config

      const authOptions = {
        router: router,
        pkce: true,
        authoriseUri: window.config.VUE_APP_SSOAUTHORIZEURL,
        tokenUri:window.config.VUE_APP_SSOACCESSTOKENURL,
        logoutUri: window.config.VUE_APP_SSOLOGOUTURL,
        postLogoutUri:  window.location.origin,
        secureApp: false,
        forceProdMode: true,
        params: {
          client_id: window.config.VUE_APP_SSOCLIENTID,
          redirect_uri: encodeURIComponent(window.config.VUE_APP_SSOREDIRECTURL),
          scope: encodeURIComponent(window.config.VUE_APP_SSOSCOPE)
        }
      };

      Vue.use(OAuth, authOptions);
      

       new Vue({
        router,
        store,
        render: h => h(App),
        mixins: [handleRoles],
        data:{
          isLoading:false,
          modalDescription:"",
          modalHeadline:"",
          modalIsOpen:false,
          modalLabel:"Close",
          modalCancellable:false,
          withoutCancelBtn: false,
          authVerificationCode:"",
          selectedItems: [],
          scanRequired: true
        },
        mounted() {
          store.dispatch('SET_VERSION', packageJson.version);
      
          console.log('configJson.env > ' + window.config.env);
          
        },
        methods: {
          translateMessage:function( message, title)
          {      
            let pars={
              code:"unknown",
              message: "Unknown",
              title: "Warning"
            };
            if( title)
            {
              pars.title=title;
            }
            if( typeof message === 'object' && message !== null)
            {
              pars=Object.assign(pars, message);
              if( !pars.message)
              {
                pars.message=message.toString();
              }
            }
            else
            {
              pars.message=message.toString();
            }
            const lang="en";
      
            let tmpMessage={
              message:pars.message,
              title: pars.title
            };
            const TODO="@" + "TODO";
            if( MESSAGES[ pars.code])
            {
              let tmp= MESSAGES[pars.code];
              
              if( Array.isArray(tmp))
              {
                let item = tmp.find( check=>{return check.message === pars.message});
      
                if( !item)
                {
                  const m={
                    message: pars.message,
                    translation: TODO
                  };
                  tmp.push(m);
                }
                else
                {
                  if( item.translation && item.translation !== TODO && item.translation[lang])
                  {
                    if( item.translation[lang].message)
                    {
                      tmpMessage.message=item.translation[lang].message;
                    }
                    
                    if( item.translation[lang].title)
                    {
                      tmpMessage.title=item.translation[lang].title;
                    }
                  }
                }
              }
              else{
                
                if( tmp.message !== pars.message)
                {
                  const m={
                    message: pars.message,
                    translation: TODO
                  };
                  let a=[tmp];
                  a.push(m );
                  MESSAGES[pars.code]=a;
                }
                else
                {
                  if( tmp.translation && tmp.translation !== TODO && tmp.translation[lang])
                  {
                    if( tmp.translation[lang].message)
                    {
                      tmpMessage.message=tmp.translation[lang].message;
                    }
                    
                    if( tmp.translation[lang].title)
                    {
                      tmpMessage.title=tmp.translation[lang].title;
                    }
                  }
                }
              }
            }
            else
            {
              const m={
                message: pars.message,
                translation: TODO
              };
              MESSAGES[pars.code]=m;
            }
            
            return tmpMessage;
          },
          showModal: function( options){
            this.modalDescription=options.message?options.message.toString():"";
            this.modalHeadline=options.title?options.title.toString():"Error";
            this.modalIsOpen=true;
            this.modalCancellable=options.cancellable;
      
            this.$root.$off("modal:primary");
            if(options.withoutCancelBtn){
              this.withoutCancelBtn = options.withoutCancelBtn;
            }
            if( options.action)
            {
              this.$root.$on("modal:primary", options.action);
            }
            if( options.button)
            {
              this.modalLabel=options.button;
            }
            else
            {
              if( this.modalCancellable)
              {
                this.modalLabel="Continue";
              }
              else
              {
                this.modalLabel="Close";
              }
            }
          },
          translateModal: function(reason, title="Warning",options){
      
            let m=this.translateMessage(reason, title);
      
            let tmp=Object.assign( {}, m);
            if(options)
            {
              Object.assign(tmp, options);
            }
            this.showModal(tmp);
          }
        }
      }).$mount("#app");
  })


